import React, { useEffect, useState } from "react";
import { PackageService } from "../../../services";
import { toast } from "react-toastify";

import { Success } from "../../Payment/Success";
import { Failed } from "../../Payment/Failed";

import Popup from "../../Popup";
import {
  activePlans,
  addPaymentDetails,
  createRazorpayOrder,
  getPackageDetails,
  paymentVisit,
} from "../../../asiosConfig";

import {
  getAllPackagesJava,
  createOrderJava,
  submitAssistedEnquiryJava,
  insertPaymentJava,
} from "../../../javaAxiosConfig";

import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Card,
  Chip,
  Button,
  Skeleton,
  Divider,
} from "@mui/material";
import starBathlehem from "../../../images/Star of Bethlehem.png";
import contact from "../../../images/contactviewedIcon.png";
import phoneIcon from "../../../images/premuim-assistIcon.png";
import Guarantee from "../../../images/Guarantee.png";
import defaultIcon from "../../../images/medal.png";
import goldIcon from "../../../images/goldIcon.svg";
import platinumIcon from "../../../images/goldIcon.svg";
import diamondIcon from "../../../images/goldIcon.svg";
import premiumPlusIcon from "../../../images/goldIcon.svg";
import tillUMarryIcon from "../../../images/goldIcon.svg";

import upgradeStar from "../../../images/upgradeStar.png";

import doubleRightArrow from "../../../images/doubleRightArrow.svg";

import styled from "styled-components";

const Container = styled(Box)`
  max-width: 100%;
  margin: auto;
  text-align: center;
  padding: 16px;
  @media (max-width: 600px) {
    padding: 8px;
  }
`;

const Header = styled(Box)`
  background: linear-gradient(90deg, #acd9f9 0%, #c2fedb 100%);
  padding: 20px;
  color: white;
  font-weight: bold;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

const CardContainer = styled(Card)`
  margin: 16px 0;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const IconButton = styled(Button)`
  background-color: #00c4cc;
  color: white;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
`;

const TopSectionWrapper = styled(Box)`
  position: relative;
  margin-top: 56px; /* space for floating banner */
`;

// const GradientBanner = styled(Box)`
//   position: absolute;
//   top: -28px;
//   left: 50%;
//   transform: translateX(-50%);
//   background:
//     linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)),
//     linear-gradient(90deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81));
//   border-radius: 999px;
//   padding: 14px 36px;
//   color: #fff;
//   font-weight: 600;
//   text-align: center;
//   box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
//   z-index: 10;

//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 6px;

//   max-width: 90%;
//   width: max-content;

//   font-size: 14px;

//   @media (max-width: 768px) {
//     padding: 12px 24px;
//     font-size: 13px;
//     max-width: 95%;
//   }

//   @media (max-width: 480px) {
//     padding: 10px 16px;
//     font-size: 12px;
//     border-radius: 20px;

//     max-width: 80%;
//     width: max-content;
//   }
// `;


const GradientBanner = styled(Box)`
  position: ${(props) => (props.free ? "relative" : "absolute")};
  top: ${(props) => (props.free ? "0" : "-28px")};
  left: ${(props) => (props.free ? "auto" : "50%")};
  transform: ${(props) => (props.free ? "none" : "translateX(-50%)")};

  margin: ${(props) => (props.free ? "0 auto 24px auto" : "0")};

  background:
    linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)),
    linear-gradient(90deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81));

  border-radius: 999px;
  padding: 14px 36px;
  color: #fff;
  font-weight: 600;
  text-align: center;
  box-shadow: 0 4px 20px 0px rgba(0, 0, 0, 0.18);
  z-index: 10;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  width: 80%;
  min-width: 70%;
`;

const StatusCardWrapper = styled(Box)`
  display: flex;
  gap: 20px;
  margin-top: 2px;
  flex-wrap: wrap;
`;

const StatusCard = styled(Box)` 
  flex: 1;
  min-width: 220px;
  background: ${(props) =>
    props.active ? "#ffffff" : "rgba(255, 240, 240, 0.5)"};
  border-radius: 20px;
  padding: 24px;
  text-align: center;
  position: relative;
  border: ${(props) => (props.active ? "1px solid #ffd6c9" : "none")};
`;

// const ActiveChip = styled(Box)`
//   position: absolute;
//   top: 16px;
//   right: 16px;
//   background: #ff9a44;
//   color: #fff;
//   font-size: 12px;
//   padding: 4px 10px;
//   border-radius: 12px;
// `;

const ActiveChip = styled(Box)`
  position: absolute;
  top: 16px;
  right: 0; /* flush to right like Figma */

  height: 25px;
  min-width: 66px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0 16px;

  border-radius: 50px 0 0 50px;

  background:
    linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)),
    linear-gradient(90deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81));

  color: #fff;
  font-size: 12px;
  font-weight: 700;
  font-family: "Montserrat", sans-serif;
  letter-spacing: 0.5px;

  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);

  z-index: 5;

  /* Responsive */
  @media (max-width: 768px) {
    height: 22px;
    font-size: 11px;
    padding: 0 12px;
  }

  @media (max-width: 480px) {
    height: 20px;
    font-size: 10px;
    padding: 0 10px;
  }
`;

const TabsWrapper = styled(Box)`
  display: flex;
  border-radius: 10px;
  background: #fff;
  border: 1.8px solid #ffd6c9;
  overflow: hidden;
`;

const TabItem = styled(Box)`
  flex: 1;
  padding: 14px 0;
  text-align: center;
  font-weight: 600;
  cursor: pointer;
  background: ${(props) =>
    props.active ? "rgba(255, 240, 240, 0.5)" : "#fff"};
  color: ${(props) => (props.active ? "#ff4e50" : "#555")};
  position: relative;

  /* REMOVE border-bottom */

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: ${(props) => (props.active ? "35%" : "0")}; /* 👈 30–40% */
    height: 3px;
    background: linear-gradient(90deg, #ff9a44, #ff4e50);
    border-radius: 6px;
    transition: width 0.25s ease;
  }
`;

const PackageGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(255px, 1fr));
  gap: 40px 20px; /* ⬅ increased */
  margin-top: 32px;
  padding-bottom: 40px; /* ⬅ space for floating buttons */
`;

const PackageCard = styled(Box)`
  border-radius: 24px;
  padding: 28px;
  background: #fff;
  box-shadow: ${(props) =>
    props.selected
      ? "0 7px 20px 0px rgba(79,79,79,0.2)"
      : "0 4px 6px rgba(0,0,0,0.08)"};
  transform: ${(props) => (props.selected ? "scale(1.05)" : "scale(1)")};
  transition: all 0.25s ease;
  position: relative;
  text-align: start;
`;

const PriceTag = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(180deg, #ff9a44, #ff4e50);
  color: #fff;
  padding: 6px 14px;
  border-bottom-left-radius: 16px;
  font-weight: 700;
`;

const packageIcons = {
  Gold: goldIcon,
  Platinum: platinumIcon,
  Diamond: diamondIcon,
  Classic: premiumPlusIcon,
  Prime: premiumPlusIcon,
  Royal: tillUMarryIcon,
  Elite: tillUMarryIcon,
};

export const Upgrade = () => {
  const [packageDetails, setPackageDetails] = useState({});
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [activePackage, setActivePackage] = useState({});
  const [loading, setLoading] = useState(true);

  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("success");

  const [isPaymentFlow, setIsPaymentFlow] = useState(false);

  const [paymentResult, setPaymentResult] = useState(null);
  // values: null | "success" | "failed"
  const [paymentMeta, setPaymentMeta] = useState(null);

  const [activeTab, setActiveTab] = useState("premium_plan");

  const navigate = useNavigate();
  const user = localStorage.getItem("user");

  const normalizePackages = (apiData) => {
    return {
      premium_plan: {
        description: apiData["Premium"]?.[0]?.description || [],
        packages:
          apiData["Premium"]?.map((p) => ({
            package_id: p.packageId,
            package_name: p.packageVariant,
            valid_period: p.validPeriodDays,
            phone_number_allowed: p.phoneNumbersAllowed,
            after_discount_price: p.price.finalPrice,
            discount_type: p.price.discountType,
            discount_value: p.price.discountValue,
            original_price: p.price.originalPrice,

            opinion: p.opinion,
          })) || [],
      },

      premium_plus_plan: {
        description: apiData["Premium+"]?.[0]?.description || [],
        packages:
          apiData["Premium+"]?.map((p) => ({
            package_id: p.packageId,
            package_name: p.packageVariant,
            valid_period: p.validPeriodDays,
            phone_number_allowed: p.phoneNumbersAllowed,
            after_discount_price: p.price.finalPrice,
            discount_type: p.price.discountType,
            discount_value: p.price.discountValue,
            original_price: p.price.originalPrice,

            opinion: p.opinion,
          })) || [],
      },

      assisted: {
        description: apiData["Assisted"]?.[0]?.description || [],
        packages:
          apiData["Assisted"]?.map((p) => ({
            package_id: p.packageId,
            package_name: p.packageVariant,
            valid_period: p.validPeriodDays,
            phone_number_allowed: p.phoneNumbersAllowed,
            after_discount_price: p.price.finalPrice,
            discount_type: p.price.discountType,
            discount_value: p.price.discountValue,
            original_price: p.price.originalPrice,

            opinion: p.opinion,
          })) || [],
      },
    };
  };

  const fetchActivePlan = async () => {
    try {
      console.log("[UPGRADE] fetching active plan after payment");
      const data = await activePlans();
      setActivePackage(data.data);
    } catch (error) {
      console.error("[UPGRADE] fetchActivePlan error", error);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchPackageDetails = async () => {
      try {
        // const data = await getPackageDetails();
        // setPackageDetails(data.data.data);

        const res = await getAllPackagesJava();
        // const normalized = normalizePackages(res.data.data);

        const apiData = res?.data?.data || res?.data;

        if (!apiData) {
          throw new Error("Invalid package response");
        }

        const normalized = normalizePackages(apiData);
        setPackageDetails(normalized);
      } catch (error) {
        // toast.error(error.response.data.message);
        toast.error(
          error?.response?.data?.message ||
            error?.message ||
            "Failed to load packages",
        );
      }
    };

    fetchPackageDetails();
    fetchActivePlan();
  }, []);

  const handleAssistedEnquiry = async () => {
    try {
      const res = await submitAssistedEnquiryJava({
        userId: localStorage.getItem("userId"),
        name: localStorage.getItem("full_name"),
        mobile: localStorage.getItem("mobileNumber"),
        gender: localStorage.getItem("gender") === "M" ? "Male" : "Female",
        location: localStorage.getItem("location"),
      });

      setPopupType("success");
      setPopupMessage(res?.data?.message);
      setPopupOpen(true);
    } catch (error) {
      setPopupType("error");
      setPopupMessage(
        error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
      setPopupOpen(true);
    }
  };

  const addPaymentView = async (plan) => {
    try {
      const payload = {
        package_id: plan.package_id,
        package_name: plan.package_name,
        package_price: plan.after_discount_price,
        valid_period: plan.valid_period,
        token: localStorage.getItem("token"),
      };

      console.log("[PAYMENT VISIT] payload:", payload);

      await paymentVisit(payload);
    } catch (error) {
      console.error("[PAYMENT VISIT ERROR]", error?.response?.data || error);
    }
  };

  const handleRadioChange = (plan) => {
    setSelectedPlan(plan);
  };

  const getUserId = () => {
    try {
      const userObj = JSON.parse(localStorage.getItem("user"));
      return userObj?.id;
    } catch {
      return null;
    }
  };

  const handlePayment = async () => {
    if (!selectedPlan) {
      toast.error("Please select a package to proceed with payment");
      return;
    }

    try {
      // 1. Record visit
      await addPaymentView(selectedPlan);

      const userId = Number(localStorage.getItem("userId"));

      console.log("[PAYMENT] userId being sent:", userId);

      if (!userId) {
        toast.error("User not identified. Please login again.");
        return;
      }

      console.log("[PAYMENT] Selected plan:", selectedPlan);

      const res = await createOrderJava({
        amount: selectedPlan.after_discount_price,
        userId,
        packageId: selectedPlan.package_id,
      });

      console.log("[PAYMENT] createOrderJava response:", res.data);

      if (!res.data.success) {
        toast.error("Failed to create order");
        return;
      }

      const { orderId, amount, currency, apiKey } = res.data;

      // 🔥 store orderId for insert payment API
      localStorage.setItem("latestOrderId", orderId);

      const options = {
        // key: razorpayKey,
        key: apiKey,
        order_id: orderId,

        amount: amount,
        currency: currency,
        name: "Upgrade Membership",
        description: "Upgrade Membership",
        // order_id: order_id,

        handler: async function (response) {
          console.log("[RAZORPAY] success response:", response);
          try {
            console.log(
              "[PAYMENT FLOW] Razorpay success, showing success modal",
            );

            setIsPaymentFlow(false);
            toast.success("Payment Successful");

            setPaymentResult("success");
            setPaymentMeta({
              package: {
                ...selectedPlan,
                package_price: selectedPlan.after_discount_price, // 🔥 REQUIRED BY UI

                original_price: selectedPlan.original_price,
              },
              payment_id: response.razorpay_payment_id,
            });
          } catch (error) {
            toast.error("Something went wrong while recording payment details");
          }
        },
        prefill: {
          name: localStorage.getItem("user_name") || "",
          email: localStorage.getItem("email"),
          contact: "1234567890",
        },
        notes: {
          plan_id: selectedPlan.package_id,
        },
        theme: {
          color: "#666666",
        },

        modal: {
          ondismiss: () => {
            console.log("[PAYMENT FLOW] Razorpay dismissed / failed");

            setIsPaymentFlow(false);

            setPaymentResult("failed");
            setPaymentMeta({
              package: {
                ...selectedPlan,
                package_price: selectedPlan.after_discount_price, // 🔥 REQUIRED
                original_price: selectedPlan.original_price,
              },
              payment_id: orderId || "N/A",
            });

            console.log("[PAYMENT FAILED META]", {
              package: selectedPlan,
              orderId,
            });
          },
        },
      };

      // console.log("[RAZORPAY] options:", options);

      setIsPaymentFlow(true);
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      toast.error("Something went wrong during payment initialization");
      console.error(error);
    }
  };

  if (loading) {
    return (
      <div className="col-lg-9 col-12">
        <Skeleton variant="text" width="80%" height={40} />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={150}
          sx={{ mt: 2 }}
        />
        <Skeleton variant="text" width="50%" height={30} sx={{ mt: 2 }} />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={100}
          sx={{ mt: 2 }}
        />
        <Skeleton variant="text" width="50%" height={30} sx={{ mt: 2 }} />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={100}
          sx={{ mt: 2 }}
        />
      </div>
    );
  }

  const isExpired = activePackage?.package_expiry_date
    ? new Date() > new Date(activePackage.package_expiry_date)
    : true;

    const isFreeUser =
  activePackage?.package_name?.trim()?.toLowerCase() === "free";

  
  const getPlanTitle = (planType) => {
    switch (planType) {
      case "premium_plan":
        return "Premium Membership Plan";
      case "premium_plus_plan":
        return "Premium Plus Membership Plan";
      case "assisted":
        return "Assisted Membership Plan";
      default:
        return planType;
    }
  };

  const montserratTypography = {
    "& .MuiTypography-root": {
      fontFamily: "'Montserrat', sans-serif",
    },
  };

  return (
    <Box className="col-lg-9 col-12" sx={montserratTypography}>
      {/* {activePackage && activePackage.package_name !== "Free" ? ( */}
      {activePackage ? (
        isExpired ? (
          <CardContainer>
            <Typography variant="h6" align="center" color="error">
              {activePackage.package_expiry_date
                ? "Your package is expired."
                : "You are currently a Free User."}
            </Typography>
          </CardContainer>
        ) : (
//           <TopSectionWrapper>
//             {/* FLOATING BANNER */}
//             <GradientBanner>
//               <span>
//                 Welcome {activePackage?.name}! Enjoy your Premium Benefits
//               </span>

//               <img
//                 src={upgradeStar}
//                 alt="star"
//                 style={{
//                   width: "22px",
//                   height: "22px",
//                   marginLeft: "8px",
//                   verticalAlign: "middle",
//                 }}
//               />
//             </GradientBanner>

//             {/* WHITE CARD */}
//             <Box
//               sx={{
//                 background: "#fff",
//                 borderRadius: "32px",
//                 padding: "64px 32px 32px",
//                 boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
//               }}
//             >

    

//               {!isFreeUser ? (
//   <StatusCardWrapper>
//     {/* Contact */}
//     <StatusCard>
//       <img src={contact} alt="Contacts" style={{ width: 35 }} />
//       <Typography variant="h6" mt={2}>
//         Contact
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         {activePackage.contact_view_count} of{" "}
//         {activePackage.phone_allowed} viewed
//       </Typography>
//     </StatusCard>

//     {/* Active Plan */}
//     <StatusCard active>
//       <ActiveChip>Active</ActiveChip>
//       <img
//         src={
//           packageIcons[activePackage.package_name?.trim()] || defaultIcon
//         }
//         alt={activePackage.package_name}
//         width={40}
//       />
//       <Typography variant="h5" mt={2}>
//         {activePackage.package_name}
//       </Typography>

//       <Typography variant="body2" mt={1}>
//         Start Date :{" "}
//         <span style={{ color: "green", fontWeight: 600 }}>
//           {new Date(
//             activePackage.created_date,
//           ).toLocaleDateString("en-GB")}
//         </span>
//       </Typography>

//       <Typography variant="body2" mt={1}>
//         Expiry :{" "}
//         <span style={{ color: "red", fontWeight: 600 }}>
//           {new Date(
//             activePackage.package_expiry_date,
//           ).toLocaleDateString("en-GB")}
//         </span>
//       </Typography>
//     </StatusCard>

//     {/* Premium Assist */}
//     <StatusCard>
//       <img src={phoneIcon} alt="Premium Assist" style={{ width: 35 }} />
//       <Typography variant="h6" mt={2}>
//         Premium Assist
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         10 AM – 7 PM
//       </Typography>
//     </StatusCard>
//   </StatusCardWrapper>
// ) : (
//   <Box textAlign="center" mt={4}>
//     <Typography
//       variant="h5"
//       fontWeight={700}
//       mb={2}
//     >
//       Welcome {activePackage?.name}
//     </Typography>

//     <Typography
//       variant="h6"
//       sx={{
//         background: "linear-gradient(90deg,#ff9a44,#ff4e50)",
//         WebkitBackgroundClip: "text",
//         WebkitTextFillColor: "transparent",
//         fontWeight: 700,
//       }}
//     >
//       Embrace the Premium Advantage
//     </Typography>
//   </Box>
// )}
              
//             </Box>
//           </TopSectionWrapper>

<TopSectionWrapper>
  {/* FLOATING BANNER */}
  <GradientBanner free={isFreeUser}>
    <span style={{fontSize: "14px"}}>
      Welcome {activePackage?.name}! Enjoy your Premium Benefits
    </span>

    {!isFreeUser && (
      <img
        src={upgradeStar}
        alt="star"
        style={{
          width: "22px",
          height: "22px",
          marginLeft: "8px",
          verticalAlign: "middle",
        }}
      />
    )}
  </GradientBanner>

  {/* ✅ ONLY SHOW WHITE BOX FOR NON-FREE USERS */}
  {!isFreeUser && (
    <Box
      sx={{
        background: "#fff",
        borderRadius: "32px",
        padding: "64px 32px 32px",
        boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
      }}
    >
      <StatusCardWrapper>
        {/* Contact */}
        <StatusCard>
          <img src={contact} alt="Contacts" style={{ width: 35 }} />
          <Typography variant="h6" mt={2}>
            Contact
          </Typography>
          <Typography variant="body2" mt={1} color="text.secondary">
            {activePackage.contact_view_count} of{" "}
            {activePackage.phone_allowed} viewed
          </Typography>
        </StatusCard>

        {/* Active Plan */}
        <StatusCard active>
          <ActiveChip>Active</ActiveChip>
          <img
            src={
              packageIcons[activePackage.package_name?.trim()] || defaultIcon
            }
            alt={activePackage.package_name}
            width={40}
          />
          <Typography variant="h5" mt={2} sx={{ fontWeight: 500 }}>
            {activePackage.package_name}
          </Typography>

          <Typography variant="body2" mt={1}>
            Start Date :{" "}
            <span style={{ color: "green", fontWeight: 600 }}>
              {new Date(
                activePackage.created_date,
              ).toLocaleDateString("en-GB")}
            </span>
          </Typography>

          <Typography variant="body2" mt={1}>
            Expiry :{" "}
            <span style={{ color: "red", fontWeight: 600 }}>
              {new Date(
                activePackage.package_expiry_date,
              ).toLocaleDateString("en-GB")}
            </span>
          </Typography>
        </StatusCard>

        {/* Premium Assist */}
        <StatusCard>
          <img src={phoneIcon} alt="Premium Assist" style={{ width: 35 }} />
          <Typography variant="h6" mt={2}>
            Premium Assist
          </Typography>
          <Typography variant="body2" mt={1} color="text.secondary">
            10 AM – 7 PM
          </Typography>
        </StatusCard>
      </StatusCardWrapper>
    </Box>
  )}
</TopSectionWrapper>
        )
      ) : (
        <Typography variant="body1" align="center">
          Upgrade to Premium to enjoy exclusive benefits!
        </Typography>
      )}

      <div className="editProfileBlock">
        <div className="profileDetailsBlock">
          {/* ===== Membership Tabs ===== */}
          <Box
            sx={{
              background: "#fff",
              borderRadius: "16px",
              padding: "0px",
              boxShadow: "0 8px 20px rgba(0,0,0,0.06)",
              marginBottom: "8px",
              marginTop: "32px",
            }}
          >
            <TabsWrapper>
              <TabItem
                active={activeTab === "premium_plan"}
                onClick={() => {
                  setActiveTab("premium_plan");
                  setSelectedPlan(null);
                }}
              >
                Premium
              </TabItem>

              <TabItem
                active={activeTab === "premium_plus_plan"}
                onClick={() => {
                  setActiveTab("premium_plus_plan");
                  setSelectedPlan(null);
                }}
              >
                Premium +
              </TabItem>

              <TabItem
                active={activeTab === "assisted"}
                onClick={() => {
                  setActiveTab("assisted");
                  setSelectedPlan(null);
                }}
              >
                Assisted
              </TabItem>
            </TabsWrapper>
          </Box>

          {/* ===== Package Cards ===== */}
          <Box
            sx={{
              background: "#fff",
              borderRadius: "32px",
              padding: "40px 32px 40px",
              boxShadow: "0 12px 30px rgba(0,0,0,0.06)",
            }}
          >
            <PackageGrid>
              {packageDetails?.[activeTab]?.packages?.map((plan) => {
                const isSelected = selectedPlan?.package_id === plan.package_id;

                return (
                  <PackageCard
                    key={plan.package_id}
                    selected={isSelected}
                    onClick={() => setSelectedPlan(plan)}
                  >
                    <PriceTag>₹{plan.after_discount_price}</PriceTag>

                    <Typography variant="h5" mb={1} sx={{ fontWeight: 500 }}>
                      {plan.package_name}
                    </Typography>

                    <Typography variant="body2" color="text.secondary" mb={2}>
                      Membership Plan Details
                    </Typography>

                    {packageDetails?.[activeTab]?.description?.map(
                      (item, i) => (
                        <Typography key={i} variant="body2" mb={2} >
                          • {item}
                        </Typography>
                      ),
                    )}

                    {/* 🔥 Opinion (Only for non-assisted) */}
                    {activeTab !== "assisted" && plan.opinion > 0 && (
                      <Typography
                        mt={2}
                        sx={{
                          fontWeight: 600,
                          color: "#f78016e0",
                        }}
                      >
                        {plan.opinion} - Opinions
                      </Typography>
                    )}

                    {/* ✅ Duration (FOR ALL PLANS including Assisted) */}
                    <Typography mt={1} color="error" fontWeight={600} >
                      Duration – {plan.valid_period}{" "}
                      {plan.valid_period === 1 ? "month" : "months"}
                    </Typography>

                    {/* Contacts (Only non-assisted) */}
                    {activeTab !== "assisted" && plan.phone_number_allowed && (
                      <Typography variant="body2" color="text.secondary" mb={1}>
                        ({plan.phone_number_allowed} Contacts to view)
                      </Typography>
                    )}

                    {activeTab !== "assisted" && (
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: "-22px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          width: "70%",
                        }}
                      >
                        <Button
                          fullWidth
                          sx={{
                            borderRadius: "999px",
                            padding: "10px 0",
                            background: isSelected
                              ? "linear-gradient(90deg,#ff9a44,#ff4e50)"
                              : "#fff",
                            color: isSelected ? "#fff" : "#4f4f4f",
                            border: isSelected ? "1px solid #ff4e50" : "1px solid #4f4f4f67" ,
                            fontWeight: 600,
                            boxShadow: "0 8px 18px rgba(0,0,0,0.18)",
                          }}
                        >
                          {isSelected ? "Selected" : "Select Plan"}
                        </Button>
                      </Box>
                    )}
                  </PackageCard>
                );
              })}
            </PackageGrid>
          </Box>
        </div>

        <div style={{justifySelf: "end"}}>
          <Button
            disabled={activeTab !== "assisted" && !selectedPlan}
            onClick={() => {
              if (activeTab === "assisted") {
                handleAssistedEnquiry();
              } else {
                handlePayment();
              }
            }}
            sx={{
              mt: 4,
              mb: 4,
              borderRadius: "30px",
              padding: "12px 28px",
              background: "linear-gradient(90deg,#ff9a44,#ff4e50)",
              color: "#fff",
              fontWeight: 700,
              display: "flex",
      alignItems: "center",
      gap: "8px", // space between text & icon
            }}
          >
            {activeTab === "assisted"
              ? "Book Consultant"
              : "Continue to Payment"}

                <img
      src={doubleRightArrow}
      alt="arrow"
      style={{ width: "18px", height: "18px" }}
    />
          </Button>
        </div>
      </div>

      <Popup
        open={popupOpen}
        type={popupType}
        message={popupMessage}
        onClose={() => setPopupOpen(false)}
      />

      {/* {paymentResult === "success" && (
        <Success
          isModal
          data={paymentMeta}
          onClose={() => {
            setPaymentResult(null);
            fetchActivePlan(); // 👈 IMPORTANT
          }}
        />
      )} */}

      {paymentResult === "success" && (
        <Success
          isModal
          data={paymentMeta}
          onClose={() => {
            setPaymentResult(null);
            fetchActivePlan();
          }}
          onSuccessOpen={async () => {
            try {
              const orderId = localStorage.getItem("latestOrderId");

              if (!orderId) return;

              console.log("[INSERT PAYMENT] calling insert payment API");

              await insertPaymentJava({
                orderId,
                paymentStatus: true,
              });

              console.log("[INSERT PAYMENT] success");
            } catch (error) {
              console.error(
                "[INSERT PAYMENT ERROR]",
                error?.response?.data || error,
              );
            }
          }}
        />
      )}

      {paymentResult === "failed" && (
        <Failed
          isModal
          data={paymentMeta}
          onClose={() => setPaymentResult(null)}
        />
      )}
    </Box>
  );
};
